import {
	CREATE_SPIN_REWARD_REQUEST,
	CREATE_SPIN_REWARD_SUCCESS,
	CREATE_SPIN_REWARD_FAIL,
	FETCH_SPIN_REWARDS_REQUEST,
	FETCH_SPIN_REWARDS_SUCCESS,
	FETCH_SPIN_REWARDS_FAIL,
	UPDATE_SPIN_REWARD_REQUEST,
	UPDATE_SPIN_REWARD_SUCCESS,
	UPDATE_SPIN_REWARD_FAIL,
	DELETE_SPIN_REWARD_REQUEST,
	DELETE_SPIN_REWARD_SUCCESS,
	DELETE_SPIN_REWARD_FAIL,
	FETCH_SPIN_REWARD_REQUEST,
	FETCH_SPIN_REWARD_SUCCESS,
	FETCH_SPIN_REWARD_FAIL,
} from "../constants/spinTheWheelReward";

function createSpinRewardReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}

	switch (action.type) {
		case CREATE_SPIN_REWARD_REQUEST:
			return { loading: true };
		case CREATE_SPIN_REWARD_SUCCESS:
			return { loading: false, success: true, spinReward: action.payload.data };
		case CREATE_SPIN_REWARD_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function fetchSpinRewardsReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			spinRewardUpdated: false,
			error: null,
			spinRewardDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_SPIN_REWARDS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SPIN_REWARDS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinRewards: action.payload,
			};
		case FETCH_SPIN_REWARDS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateSpinRewardReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null, spinRewardUpdated: false };
	}
	switch (action.type) {
		case UPDATE_SPIN_REWARD_REQUEST:
			return { loading: true };
		case UPDATE_SPIN_REWARD_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinRewardUpdated: true,
			};
		case UPDATE_SPIN_REWARD_FAIL:
			return {
				loading: false,
				spinRewardUpdated: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

function deleteSpinRewardReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case DELETE_SPIN_REWARD_REQUEST:
			return { loading: true };
		case DELETE_SPIN_REWARD_SUCCESS:
			return {
				loading: false,
				spinRewardDeleted: true,
			};
		case DELETE_SPIN_REWARD_FAIL:
			return {
				loading: false,
				spinRewardDeleted: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

function fetchSpinRewardReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
			spinRewardUpdated: false,
			spinRewardDeleted: false,
		};
	}

	switch (action.type) {
		case FETCH_SPIN_REWARD_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SPIN_REWARD_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinReward: action.payload,
			};
		case FETCH_SPIN_REWARD_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export {
	createSpinRewardReducer,
	fetchSpinRewardsReducer,
	updateSpinRewardReducer,
	deleteSpinRewardReducer,
	fetchSpinRewardReducer,
};
